import { objectToQueryString } from '../../helpers/objectToQueryString';
import { IGetCategoriesResponse } from '../../types/categories';
import { axiosInstance } from '../axiosInstance';

export const getCategories = async (
  params?: Record<string, string | number>,
): Promise<IGetCategoriesResponse> => {
  const queryString = params ? objectToQueryString(params) : '';

  const response = await axiosInstance.get(`/categories?${queryString}`);

  return response.data;
};
